<template>
  <layout-popup>
    <template slot="header">
      Add existing schema
    </template>
    <div style="height: 100%; overflow: auto" class="pa-4">
      <v-autocomplete
        clearable
        v-model="selectedSchema"
        :items="schemas"
        item-text="name"
        item-value="id"
        label="Schema"
        class="ma-0"
      >
        <template v-slot:item="item">
          <div :data-test-schema="item.item.name">
            {{ item.item.name }}
          </div>
        </template>
      </v-autocomplete>
    </div>
    <template slot="footer">
      <v-spacer></v-spacer>
      <v-btn text @click="close">Cancel</v-btn>
      <v-btn
        color="primary"
        text
        @click="handleSave"
        :disabled="!selectedSchema"
      >
        save
      </v-btn>
    </template>
  </layout-popup>
</template>

<script>
import LayoutPopup from '@/layouts/LayoutPopup';
import { onMounted, reactive, ref, toRefs } from '@vue/composition-api';
import useSchemas from '@/api/schemas';
export default {
  components: {
    LayoutPopup
  },
  name: 'AddSchemaFragment',
  props: ['id'],
  setup(props, { emit }) {
    const { schemas: schemasApi, schema } = new useSchemas();
    const handleSave = () => {
      schema
        .updateSchema(state.selectedSchema, {
          parentSchemaId: props.id
        })
        .then(() => {
          close();
        })
        .finally(() => {
          schema.loading.value = false;
        });
    };
    const state = reactive({
      schemas: [],
      selectedSchema: null
    });

    const close = () => {
      emit('close');
    };

    onMounted(() => {
      schemasApi.loadPureSchemata().then(({ schemata }) => {
        state.schemas = schemata;
      });
    });

    return {
      ...toRefs(state),
      close,
      handleSave
    };
  }
};
</script>
